import React, { useState } from "react";
import { Icon } from "@shopify/polaris";
import { CircleTickMajor } from "@shopify/polaris-icons";
import { useSelector } from "react-redux";

export default function Tick({ element }: any) {
    const [completed, setCompleted] = useState(false);
    const activeInspectionUpdated = useSelector(
        (state: any) => state.portal.activeInspection?.localUpdateTime
    );

    if (completed && element.Images && element.Images.length === 0) {
        setCompleted(false);
    }

    React.useEffect(() => {
        const data = element;

        if (data) {
            if (data.MinItems == null) {
                setCompleted(false);
            } else {
                const count = data.Images.length;
                if (count >= data.MinItems) {
                    setCompleted(true);
                } else {
                    setCompleted(false);
                }
            }
        }
    }, [element, activeInspectionUpdated]);
    return completed ? <Icon color="success" source={CircleTickMajor} /> : null;
}
